import FileUploadIcon from '@mui/icons-material/FileUpload';
import React from 'react';
import {Box, ListItemText} from '@mui/material';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';

/**
 * @param {File} file
 * @param {function(File)} setFile
 * @param {Object} style
 * @return {JSX.Element}
 * @constructor
 */
export const FileUploadComponent = ({file, setFile, style}) => {
    if(file === null) {
        return <label
            className="fileUploadComponent-uploadLabel"
            style={{...style}}
        >
            <FileUploadIcon fontSize="large" sx={{fontSize: '40px', paddingBottom: '20px'}} />
            Upload file from computer or drag
            <input
                // Hidden file input
                type='file'
                multiple={false}
                accept='*'
                hidden
                // Events
                onChange={(event) => {
                    if (event.target.files.length > 0) {
                        const file = event.target.files[0];
                        if(file instanceof File) {
                            setFile(file);
                        }
                    }
                }}
            />
        </label>;
    } else {
        return <Box className="fileUploadComponent-fileBox" style={{...style}}>
            <FilePresentIcon
                className="fileUploadComponent-fileBoxItem"
                sx={{color: '#FFFFFF', backgroundColor: '#66A621', padding: '10px', borderRadius: '5px', width: '50px', height: '50px'}}
            />
            <ListItemText
                className="fileUploadComponent-fileBoxItem"
                primary={<b>{file.name}</b>}
                secondary={(Math.round(file.size/1000)/1000) + " MB"}
            />
            <div style={{height: '100%'}}>
                <CloseIcon
                    sx={{position: 'relative', right: '5px', top: '5px'}}
                    onClick={() => {setFile(null)}}
                />
            </div>
        </Box>;
    }

}

FileUploadComponent.propTypes = {
    file: PropTypes.object,
    setFile: PropTypes.func,
    style: PropTypes.object,
};
